import sample_1 from './sample1.jpeg';

export const mewaPureImpressions = {
    sample_1,
};
